export default "__VITE_ASSET__83abbaf9__"